import { Badge } from "@/components/ui/others/Badges";

interface CollabedBadgeProps {
  position?: "left" | "right";
}

const BADGE_CONFIG = {
  containerSize: "90px",
  badgeWidth: "112px",
  badgeHeight: "16px",
  backgroundColor: "#3c8a6f",
} as const;

export function CollabedBadge({ position = "left" }: CollabedBadgeProps) {
  const isLeft = position === "left";

  const containerClasses = `absolute ${isLeft ? "left-0" : "right-0"} top-0 z-10 overflow-hidden`;

  const badgePosition = {
    left: isLeft ? "-30px" : "0",
    right: isLeft ? "-30px" : "0",
    top: isLeft ? "13px" : "20px",
    transform: isLeft ? "rotate(-45deg)" : "rotate(45deg)",
    transformOrigin: "center",
    width: isLeft ? BADGE_CONFIG.badgeWidth : "130px",
  };

  return (
    <div
      className={containerClasses}
      style={{
        width: BADGE_CONFIG.containerSize,
        height: BADGE_CONFIG.containerSize,
        zIndex: 5,
      }}
    >
      <div
        className="absolute flex items-center justify-center"
        style={badgePosition}
      >
        <Badge
          className="px-7 py-0.5 text-[12px] font-normal text-white tracking-[-0.24px] rounded-none border-none text-center whitespace-nowrap"
          style={{
            backgroundColor: BADGE_CONFIG.backgroundColor,
            width: BADGE_CONFIG.badgeWidth,
            height: BADGE_CONFIG.badgeHeight,
          }}
        >
          Collabed
        </Badge>
      </div>
    </div>
  );
}
